import { render } from "./SectionPdf.vue?vue&type=template&id=7c827a94&scoped=true"
import script from "./SectionPdf.vue?vue&type=script&lang=js"
export * from "./SectionPdf.vue?vue&type=script&lang=js"

import "./SectionPdf.vue?vue&type=style&index=0&id=7c827a94&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c827a94"]])

export default __exports__